module.exports = __webpack_public_path__ + "img/syukyaku-landing-002.3ba28582.jpg";